module.exports = __webpack_public_path__ + "assets/img/card-member.c1acae1f.png";